import { render } from "./UiPrcStatus.vue?vue&type=template&id=5263990c&scoped=true"
import script from "./UiPrcStatus.vue?vue&type=script&lang=js"
export * from "./UiPrcStatus.vue?vue&type=script&lang=js"

import "./UiPrcStatus.vue?vue&type=style&index=0&id=5263990c&scoped=true&lang=css"

import exportComponent from "/home/runner/work/studyflow-frontend/studyflow-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5263990c"]])

export default __exports__